const printButton = document.querySelectorAll('.js-print-button');

function printOnClick() {
	for (var i = printButton.length - 1; i >= 0; i--) {
		printButton[i].addEventListener('click', (e) => {
			e.preventDefault();
			window.print();
		})
	}
}

if(printButton.length > 0){
	printOnClick();
}




// WEBPACK FOOTER //
// ./modules/printPage.js